"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CatalogSettingClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("../../authenticated.client");
const settings_1 = require("../../../settings");
class CatalogSettingClient extends authenticated_client_1.AuthenticatedClient {
    constructor(settings = settings_1.DefaultClientSettings) {
        super(settings);
        this.settings = settings;
        this.entityPath = 'catalogs';
        this.version = 'v1';
        this.executor.setFormatDateWithTimezone(true);
    }
    getPath(identifiers, parameters) {
        let result = `/${this.version}/projects/${identifiers.projectId}/settings/${this.entityPath}`;
        if (identifiers.catalogId) {
            result += `/${identifiers.catalogId}`;
        }
        if (parameters) {
            result += `?${this.getQueryString(parameters)}`;
        }
        return result;
    }
    getFeedInfo(projectId, catalogFeed) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/catalog-info/feed-info`;
            const response = yield this.httpPost(url, catalogFeed);
            return response.payload;
        });
    }
    getAll(projectId, parameters) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = this.getPath({ projectId }, parameters);
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    getById(projectId, catalogId, fields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = this.getPath({ projectId, catalogId }, { fields });
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    create(projectId, catalogSetting) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = this.getPath({ projectId });
            const payload = Object.assign({}, catalogSetting);
            const response = yield this.httpPost(url, payload);
            return response.payload;
        });
    }
    update(projectId, catalogId, catalogSetting) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = this.getPath({ projectId, catalogId });
            const payload = Object.assign({}, catalogSetting);
            const response = yield this.httpPut(url, payload);
            return response.payload;
        });
    }
    delete(projectId, catalogId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = this.getPath({ projectId, catalogId });
            yield this.httpDelete(url);
        });
    }
}
exports.CatalogSettingClient = CatalogSettingClient;
//# sourceMappingURL=catalog-setting.client.js.map